var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81281 0.0182467C4.67608 0.0319195 4.36161 0.103018 4.16745 0.163177C3.28419 0.433898 2.61696 1.10386 2.3271 2.009C2.17123 2.49848 2.15483 2.66803 2.14115 3.94233L2.12748 5.11271H1.06374H0V6.37061V7.6285H1.06647H2.13295V10.8142V14H3.43186H4.73077V10.8142V7.6285H5.80545H6.87739L7.036 6.38975C7.1235 5.71158 7.1946 5.14553 7.19187 5.13186C7.19187 5.12092 6.63675 5.11271 5.95858 5.11271H4.7253L4.73624 4.13374C4.74718 3.204 4.74991 3.14931 4.81007 2.96609C4.85929 2.81296 4.90305 2.74733 5.01516 2.63521C5.27221 2.37816 5.55661 2.32347 6.68051 2.32347H7.2739V1.20504V0.0866108L7.11803 0.0702028C6.56292 0.0100431 5.18471 -0.0227718 4.81281 0.0182467Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.01224efa90ed9da5b3b019de7332ce1d.svg";
export { ForwardRef as ReactComponent };